module.exports = __webpack_public_path__ + "static/img/Sagittarius.55f8f2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/zodiac_image/Sagittarius.svg
// module id = 1402
// module chunks = 0